var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title text--secondary"},[_vm._v(_vm._s(_vm.$ft(_vm.state.name)))]),_c('div',{staticClass:"text--disabled mt-n1"},[_vm._v(" "+_vm._s(_vm.$t("common.placeholder.todo"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }